
import { LightningElement, api } from 'lwc';

export default class gwSlider extends LightningElement {
    @api min = 0; 
    @api max = 100;
    @api step = 1;
    @api currentValue = 0;

    @api suppressLabel = false;

    @api 
    set fontSize(value) {
        this._fontSize = value;
        if (value) {
            this._applyVarsDirect('--slider-font-size', value);
        }
    } 
    get fontSize() {
        return this._fontSize;
    }
    @api 
    set fontColor(value) {
        this._fontColor = value;
        if (value) {
            this._applyVarsDirect('--slider-font-color', value);
        }
    } 
    get fontColor() {
        return this._fontColor;
    }


    @api getValue() {
        return this.currentValue;
    }

    handleInput(event) {
        this.currentValue = event.target.value;
    }
    handleChange(event) {
        console.log('in handle change of gwSlider.js: ', event.target.value);
        this.currentValue = event.target.value;
        this.dispatchEvent(new CustomEvent('sliderchange', { detail: this.currentValue } ));
    }

    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null) {

        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }

        
        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    this.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    this.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            this.style.setProperty(cssVar,  varStyle);
        }
    }
}